

import React from 'react';

import { useLanguage } from '../../contexts/languageContext';

import Section from '../section/section';
import {
  faArrowUpRightFromSquare,
  faBusinessTime,
  faChain,
  faEnvelope,
  faGlobe,
  faHome,
  faPhone,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { faB } from '@fortawesome/free-solid-svg-icons';
import PersonalSkillsChart from '../chart/personalSkillsCore';
import TechnicalLovingChart from '../chart/technicalLovingChart';
import ProgressBar from 'react-bootstrap/ProgressBar';
import MicrosoftCertifiedAssociateBadge from '../../assets/MicrosoftCertifiedAssociateBadge.png';
import MCPBadge from '../../assets/MCPBadge.png';
import CefrielAgileCertificationBadge from '../../assets/CefrielAgileCertificationBadge.png';
import CsharpCertification from '../../assets/CsharpCertification.png';
import SqlServerCertification from '../../assets/SqlServerCertification.jpeg';
import CertificationAgile from '../../assets/CertificationAgile.png';
import CsharpBadge from '../../assets/CsharpBadge.png';
import AzureAdministratorCertification from '../../assets/AzureAdministratorCertification.jpeg';
import UniversityOfMerilandBadge from '../../assets/UniversityOfMerilandBadge.png';
import PqcCertification from '../../assets/PqcCertification.jpeg';
import IBMBadge from '../../assets/IBMbadge.png';
import IBMCyberdefenceCertification from '../../assets/IBMCyberdefenceCertification.jpeg';
import TAISEBadge from '../../assets/TAISEBadge.png';
import TAISECertificate from '../../assets/TAISE.png';
import newspaper from '../../assets/newspaper.jpeg';
import './body.scss';
import ResourceViewerModal from '../resource-viewer-modal/ResourceViewerModal';
import KnowledgeViewer from '../knowledge/KnowledgeViewer';
import { trackEvent } from '../../lib/analytics';
const Body: React.FC = () => {
  library.add(fas, faB);
  const {  t } = useLanguage();
  const publicUrl = process.env.PUBLIC_URL || '/';
  const homepageUrl = /^https?:\/\//i.test(publicUrl)
    ? publicUrl
    : new URL(publicUrl, window.location.origin).href;
 
 
   
  return (
    <div className="cointainer-fluid ms-2 me-2">
      {/* <div className="d-flex  align-items-center justify-content-center vh-100"> */}
      <div className="row">
        {/* <div className="align-self-stretch me-2 "> */}
        <div className="col-12 col-md-4 col-lg-3 left-column">
          <Section>
            <h5 className="text-secondary m-2"> {t('contactInfo')} </h5>
            <ul className="list-group list-group-flush m-2 border-0 ">
              <li className="d-flex justify-content-between align-items-start ">
                <FontAwesomeIcon icon={faHome} />
                <span style={{ fontSize: '0.9rem' }}>{t('location')}</span>
              </li>
              <li className="d-flex justify-content-between align-items-start">
                <FontAwesomeIcon icon={faPhone} />
                <a href={`callto:${t('contactPhone')}`} style={{ fontSize: '0.9rem' }}>
                  {t('contactPhone')}
                </a>
              </li>
              <li className="d-flex justify-content-between align-items-start">
                <FontAwesomeIcon icon={faEnvelope} />
                <a href={`mailto:${t('contactEmailAddress')}`} style={{ fontSize: '0.9rem' }}
                   onClick={() => { try { trackEvent('contact_me_click', { source: 'contact_section_email' }); } catch {} }}>
                  {t('contactEmail')}
                </a>{' '}
              </li>
              <li className="d-flex justify-content-between align-items-start">
                <FontAwesomeIcon icon={faLinkedinIn} />
                <a href={`${t('linkedinProfileUrl')}`} style={{ fontSize: '0.9rem' }} target='_blank' rel="noopener noreferrer"
                   onClick={() => { try { trackEvent('contact_me_click', { source: 'contact_section_linkedin' }); } catch {} }}>
                  {t('linkedinProfileText')}
                </a>
              </li>
              <li className="d-flex justify-content-between align-items-start">
                <FontAwesomeIcon icon={faGlobe} />
                <a href={homepageUrl}  target='_blank' rel="noopener noreferrer">
                  /lagitfolio
                </a>
            
              </li>
              <li className="d-flex justify-content-between align-items-start ">
                <FontAwesomeIcon icon={faBusinessTime} />
                <span style={{ fontSize: '0.9rem' }}>{t('availableWorkingTime')} &#x1F51D;</span>
              </li>
            </ul>
          </Section>
          <Section>
            <h5 className="text-secondary m-2"> {t('techStack')} </h5>
            <div className="d-flex flex-wrap m-2">
              <span className="badge rounded-pill bg-secondary me-1 mb-1">C#</span>
              <span className="badge rounded-pill bg-secondary me-1 mb-1">SQL</span>
              <span className="badge rounded-pill bg-secondary me-1 mb-1">Angular</span>
              <span className="badge rounded-pill bg-secondary me-1 mb-1">Html</span>
              <span className="badge rounded-pill bg-secondary me-1 mb-1">Javascript</span>

              <span className="badge rounded-pill bg-secondary me-1 mb-1">TypeScript</span>
              <span className="badge rounded-pill bg-secondary me-1 mb-1">Git</span>
              <span className="badge rounded-pill bg-secondary me-1 mb-1">DevOps</span>
              <span className="badge rounded-pill bg-secondary me-1 mb-1">Blazor</span>
              <span className="badge rounded-pill bg-secondary me-1 mb-1">Pipeline</span>
              <span className="badge rounded-pill bg-secondary me-1 mb-1">Redis</span>
              <span className="badge rounded-pill bg-secondary me-1 mb-1">Rabbit Mqtt</span>
              <span className="badge rounded-pill bg-secondary me-1 mb-1">Docker</span>
              <span className="badge rounded-pill bg-secondary me-1 mb-1">Podman</span>
              <span className="badge rounded-pill bg-secondary me-1 mb-1">React</span>
            </div>
          </Section>
          <Section isPageBreakAvoidOnPrint={true}>
            <h5 className="text-secondary m-2"> Technical Love </h5>
            <div className="d-flex justify-content-center m-2">
              <TechnicalLovingChart />
            </div>
          </Section>
          <Section isPageBreakAvoidOnPrint={true}>
            <h5 className="text-secondary m-2"> Personal Skill </h5>
            <div className="d-flex justify-content-center m-2">
              <PersonalSkillsChart />
            </div>
          </Section>
          <Section  isPageBreakAvoidOnPrint={true}>
            <h5 className="text-secondary m-2">{t('language')}</h5>
            <div className="  m-2">
              <ul className="list-group list-group-flush m-2 border-0 ">
                <li className="row ">
                  <span className="col-4" style={{ fontSize: '0.9rem' }}>
                    {t('Italian')}
                  </span>
                  <ProgressBar
                    now={100}
                    label={`${100}%`}
                    animated
                    striped
                    variant="primary"
                    className="col p-0"
                  />
                </li>
                <li className="row">
                  <span className="col-4" style={{ fontSize: '0.9rem' }}>
                    {t('English')}
                  </span>
                  <ProgressBar
                    now={80}
                    label={`${80}%`}
                    animated
                    striped
                    variant="primary"
                    className="col p-0"
                  />
                </li>
                <li className="row ">
                  <span className="col-4" style={{ fontSize: '0.9rem' }}>
                    {t('French')}
                  </span>
                  <ProgressBar
                    now={25}
                    label={`${25}%`}
                    animated
                    striped
                    variant="primary"
                    className="col p-0"
                  />
                </li>
                <li className="row">
                  <span className="col-4" style={{ fontSize: '0.9rem' }}>
                    {t('German')}
                  </span>
                  <div className="col p-0">
                    <ProgressBar
                      now={15}
                      label={`${15}%`}
                      animated
                      striped
                      variant="warning"
                      className="p-0"
                    />
                    <small className="text-muted d-block mt-1">A1 • {t('GermanLearning')}</small>
                  </div>
                </li>
              </ul>
            </div>
          </Section>
          <Section>
            <h5 className="text-secondary m-2 mb-1">{t('Certifications')}</h5>
            <div className="m-2">
              <div className="list-group list-group-flush m-2 border-0 ">
                <div className="list-group-item p-0 mb-2">
                  <div className="d-flex w-100 justify-content-start">
                    <img
                      src={MicrosoftCertifiedAssociateBadge}
                      style={{ width: '3rem', height: '3rem' }}
                      alt={t('azureadministratorTitle')}
                    />
                    <div className="ms-3 d-flex flex-column">
                      <div>{t('azureadministratorTitle')} </div>
                      <div>
                        <small className="text-muted">
                          {t('azureAdminCertificationDate')}
                        </small>{' '}
                      </div>
                    </div>
                    <div className="ms-auto">
                      <div className="position-relative">
                        <ResourceViewerModal
                          buttonClassName="btn btn-link position-absolute  top-0 start-100 translate-middle mt-2 no-print "
                          url={AzureAdministratorCertification}
                          title={''}
                        >
                          <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                        </ResourceViewerModal>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="list-group-item p-0 mb-2">
                  <div className="d-flex w-100 justify-content-start">
                    <img
                      src={CsharpBadge}
                      style={{ width: '3rem', height: '3rem' }}
                      alt={t('microsoftcsharpTitle')}
                    />
                    <div className="ms-3 d-flex flex-column">
                      <div>{t('microsoftcsharpTitle')} </div>
                      <div>
                        {' '}
                        <small className="text-muted">
                          {t('microsoftcsharpCertificationDate')}
                        </small>
                      </div>
                    </div>
                    <div className="ms-auto">
                      <div className="position-relative">
                        <ResourceViewerModal
                          buttonClassName="btn btn-link position-absolute top-0 start-100 translate-middle mt-2 no-print "
                          url={CsharpCertification}
                          title={''}
                        >
                          <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                        </ResourceViewerModal>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="list-group-item p-0 mb-2">
                  <div className="d-flex w-100 justify-content-start">
                    <img
                      src={CefrielAgileCertificationBadge}
                      style={{ width: '3rem', height: '3rem' }}
                      alt={t('agileCertificationTitle')}
                    />

                    <div className="ms-3 d-flex flex-column">
                      <div>{t('agileCertificationTitle')} </div>
                      <div>
                        {' '}
                        <small className="text-muted">{t('agileCertificationDate')}</small>{' '}
                      </div>
                    </div>
                    <div className="ms-auto">
                      <div className="position-relative">
                        <ResourceViewerModal
                          buttonClassName="btn btn-link position-absolute top-0 start-100 translate-middle mt-2 no-print "
                          url={CertificationAgile}
                          title={''}
                        >
                          <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                        </ResourceViewerModal>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="list-group-item p-0 ">
                  <div className="d-flex w-100 justify-content-start">
                    <img
                      src={MCPBadge}
                      style={{ width: '3rem', height: '3rem' }}
                      alt={t('sqlCertificationTitle')}
                    />
                    <div className="ms-3 d-flex flex-column">
                      <div>{t('sqlCertificationTitle')} </div>
                      <div>
                        <small className="text-muted">{t('sqlCertificationDate')}</small>{' '}
                      </div>
                    </div>
                    <div className="ms-auto">
                      <div className="position-relative">
                        <ResourceViewerModal
                          buttonClassName="btn btn-link position-absolute top-0 start-100 translate-middle mt-3 no-print "
                          url={SqlServerCertification}
                          title={''}
                        >
                          <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                        </ResourceViewerModal>{' '}
                      </div>
                    </div>
                  </div>
                </div>
                        <div className="list-group-item p-0 ">
                  <div className="d-flex w-100 justify-content-start">
                    <img
                      src={UniversityOfMerilandBadge}
                      style={{ width: '3rem', height: '3rem' }}
                      alt={t('PqcCertificationTitle')}
                    />
                    <div className="ms-3 d-flex flex-column">
                      <div>{t('PqcCertificationTitle')} </div>
                      <div>
                        <small className="text-muted">{t('PqcCertificationDate')}</small>{' '}
                      </div>
                    </div>
                    <div className="ms-auto">
                      <div className="position-relative">
                        <ResourceViewerModal
                          buttonClassName="btn btn-link position-absolute top-0 start-100 translate-middle mt-3 no-print "
                          url={PqcCertification}
                          title={''}
                        >
                          <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                        </ResourceViewerModal>{' '}
                      </div>
                    </div>
                  </div>
                </div>
                            <div className="list-group-item p-0 ">
                  <div className="d-flex w-100 justify-content-start">
                    <img
                      src={IBMBadge}
                      style={{ width: '3rem', height: '3rem' }}
                      alt={t('cyberdefenceCertificationTitle')}
                    />
                    <div className="ms-3 d-flex flex-column">
                      <div>{t('cyberdefenceCertificationTitle')} </div>
                      <div>
                        <small className="text-muted">{t('cyberdefenceCertificationDate')}</small>{' '}
                      </div>
                    </div>
                    <div className="ms-auto">
                      <div className="position-relative">
                        <ResourceViewerModal
                          buttonClassName="btn btn-link position-absolute top-0 start-100 translate-middle mt-3 no-print "
                          url={IBMCyberdefenceCertification}
                          title={''}
                        >
                          <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                        </ResourceViewerModal>{' '}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="list-group-item p-0 mb-2">
                  <div className="d-flex w-100 justify-content-start">
                    <img
                      src={TAISEBadge}
                      style={{ width: '3rem', height: '3rem' }}
                      alt={t('taiseCertificationTitle')}
                    />
                    <div className="ms-3 d-flex flex-column">
                      <div>{t('taiseCertificationTitle')} </div>
                      <div>
                        <small className="text-muted">{t('taiseCertificationDate')}</small>{' '}
                      </div>
                    </div>
                    <div className="ms-auto">
                      <div className="position-relative">
                        <ResourceViewerModal
                          buttonClassName="btn btn-link position-absolute top-0 start-100 translate-middle mt-2 no-print "
                          url={TAISECertificate}
                          title={''}
                        >
                          <FontAwesomeIcon icon={faArrowUpRightFromSquare} />
                        </ResourceViewerModal>{' '}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Section>
          <Section isPageBreakAvoidOnPrint={true}>
            <h5 className="text-secondary m-2 mb-1">{t('Mention')}</h5>
            <div className="m-2">
              <h6>{t('newspaperMentionTitle')} </h6>
              <p>
                {t('newspaperMentionMessage')}{' '}
                <ResourceViewerModal
                  buttonClassName="btn btn-link no-print"
                  url={newspaper}
                  title={''}
                >
                  {t('readme')}
                </ResourceViewerModal>
              </p>
            </div>
          </Section>
          <Section isPageBreakAvoidOnPrint={true}>
            <h5 className="text-secondary m-2 mb-1">{t('Education')}</h5>
            <div className="m-2">
              <div className="list-group list-group-flush  border-0 ">
                <div className="list-group-item p-0 mb-2">
                  <div className="m-1">
                    <div className="d-flex justify-content-start">
                      <div className="flex-fill">
                        <h6>
                          <strong>{t('Degree')}</strong>{' '}
                        </h6>{' '}
                      </div>
                      <small className="text-muted">{t('thesisdate')}</small>
                    </div>
                    <strong> {t('universityThesisTitle')} </strong>
                    <p>{t('universityThesisMessage')}</p>
                  </div>
                </div>

                <div className="list-group-item p-0 mb-2">
                  <div className="m-1">
                    <div className="d-flex justify-content-start">
                      <div className="flex-fill">
                        <h6>
                          <strong> {t('University')} </strong>
                        </h6>{' '}
                      </div>
                      <small className="text-muted">{t('UniversityDuration')}</small>
                    </div>

                    <strong> {t('universityTitle')} </strong>
                    <p>{t('universityMessage')}</p>
                  </div>
                </div>
  
              </div>
            </div>
          </Section>
        </div>

        <div className="col-12 col-md-8 col-lg-9 ps-2 right-column">
          <Section  isPageBreakAvoidOnPrint={true}>
            <div className="d-flex flex-column">
              <div className="row">
                <div className="col-auto me-auto">
                  <h4 className="text-primary">{t('openlogsTitle')}</h4>
                </div>
                <div className="col-auto">
                  <div className="row">
                    {' '}
                    <div className="col-auto col-xs-12 text-end">
                      <small>{t('openlogsDuration')}</small>{' '}
                    </div>
                  </div>
                  <div className="col-auto col-xs-12 text-end">
                    <strong>{t('openlogsCompany')}</strong>{' '}
                    <a
                      href={t('openlogsLink')}
                      target="_blank"
                      rel="noreferrer"
                      aria-label="Open Openlogs website"
                      title="Open Openlogs website"
                      className="link-primary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover no-print"
                    >
                      <FontAwesomeIcon icon={faChain} />
                    </a>
                  </div>
                </div>
              </div>
              <div dangerouslySetInnerHTML={{ __html: t('openlogsMessage') }}></div>
              <div>
                {' '}
                <h5 className="text-secondary subtitle">
                  {' '}
                  {t('focusProject')} : {t('openlogsTitleFocus')}{' '}
                </h5>
              </div>
              <div>
                {' '}
                <p dangerouslySetInnerHTML={{ __html: t('openlogsFocusProjectMessage') }}></p>
              </div>
            </div>
          </Section>
          <Section  isPageBreakAvoidOnPrint={false}>
            <div className="d-flex flex-column">
              <div className="row">
                <div className="col-auto me-auto">
                  <h4 className="text-primary">{t('swatchTitle')}</h4>
                </div>
                <div className="col-auto">
                  <div className="row">
                    {' '}
                    <div className="col-auto col-xs-12 text-end">
                      <small>{t('swatchDuration')}</small>{' '}
                    </div>
                  </div>
                  <div className="col-auto col-xs-12 text-end">
                    <strong>{t('swatchCompany')}</strong>{' '}
                    <a
                      href={t('swatchgroupLink')}
                      target="_blank"
                      rel="noreferrer"
                      aria-label="Open Swatch Group website"
                      title="Open Swatch Group website"
                      className="link-primary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover no-print"
                    >
                      <FontAwesomeIcon icon={faChain} />
                    </a>
                  </div>
                </div>
              </div>
              <div dangerouslySetInnerHTML={{ __html: t('swatchMessage') }}></div>
              <div>
                {' '}
                <h5 className="text-secondary subtitle">
                  {' '}
                  {t('focusProject')} : {t('swatchTitleFocus')}{' '}
                </h5>
              </div>
              <div>
                {' '}
                <p dangerouslySetInnerHTML={{ __html: t('swatchFocusProjectMessage') }}></p>
              </div>
            </div>
          </Section>
          <Section  isPageBreakAvoidOnPrint={true}>
            <div className="d-flex flex-column">
              <div className="row">
                <div className="col-auto me-auto">
                  <h4 className="text-primary">{t('zegnaTitle')}</h4>
                </div>
                <div className="col-auto">
                  <div className="row">
                    {' '}
                    <div className="col-auto col-xs-12 text-end">
                      <small>{t('zegnaDuration')}</small>{' '}
                    </div>
                  </div>
                  <div className="col-auto col-xs-12 text-end">
                    <strong>{t('zegnaCompany')}</strong>{' '}
                    <a
                      href={t('zegnaLink')}
                      target="_blank"
                      rel="noreferrer"
                      aria-label="Open Zegna website"
                      title="Open Zegna website"
                      className="link-primary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover no-print"
                    >
                      <FontAwesomeIcon icon={faChain} />
                    </a>
                  </div>
                </div>
              </div>
              <div dangerouslySetInnerHTML={{ __html: t('zegnaMessage') }}></div>
              <div>
                {' '}
                <h5 className="text-secondary subtitle">
                  {' '}
                  {t('focusProject')} : {t('zegnaTitleFocus')}{' '}
                </h5>
              </div>
              <div>
                {' '}
                <p dangerouslySetInnerHTML={{ __html: t('zegnaFocusProjectMessage') }}></p>
              </div>
            </div>
          </Section>
          <Section  isPageBreakAvoidOnPrint={true}>
            <div className="d-flex flex-column">
              <div className="row">
                <div className="col-auto me-auto">
                  <h4 className="text-primary">{t('atgTitle')}</h4>
                </div>
                <div className="col-auto">
                  <div className="row">
                    {' '}
                    <div className="col-auto col-xs-12 text-end">
                      <small>{t('atgDuration')}</small>{' '}
                    </div>
                  </div>
                  <div className="col-auto col-xs-12 text-end">
                    <strong>{t('atgCompany')}</strong>{' '}
                    <a
                      href={t('atgLink')}
                      target="_blank"
                      rel="noreferrer"
                      aria-label="Open ATG website"
                      title="Open ATG website"
                      className="link-primary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover no-print"
                    >
                      <FontAwesomeIcon icon={faChain} />
                    </a>
                  </div>
                </div>
              </div>

              <div dangerouslySetInnerHTML={{ __html: t('atgMessage') }}></div>
              <div>
                {' '}
                <h5 className="text-secondary subtitle">
                  {' '}
                  {t('focusProject')} : {t('atgTitleFocus')}{' '}
                </h5>
              </div>
              <div>
                {' '}
                <p dangerouslySetInnerHTML={{ __html: t('atgFocusProjectMessage') }}></p>
              </div>
            </div>
          </Section>
          <Section  isPageBreakAvoidOnPrint={true}>
            <div className="d-flex flex-column">
              <div className="row">
                <div className="col-auto me-auto">
                  <h4 className="text-primary">{t('oltrebaseTitle')}</h4>
                </div>
                <div className="col-auto">
                  <div className="row">
                    {' '}
                    <div className="col-auto col-xs-12 text-end">
                      <small>{t('oltrebaseDuration')}</small>{' '}
                    </div>
                  </div>
                  <div className="col-auto col-xs-12 text-end">
                    <strong>{t('oltrebaseCompany')}</strong>{' '}
                    <a
                      href={t('oltrebaseLink')}
                      target="_blank"
                      rel="noreferrer"
                      aria-label="Open Oltrebase website"
                      title="Open Oltrebase website"
                      className="link-primary link-offset-2 link-underline-opacity-25 link-underline-opacity-100-hover no-print"
                    >
                      <FontAwesomeIcon icon={faChain} />
                    </a>
                  </div>
                </div>
              </div>

              <div dangerouslySetInnerHTML={{ __html: t('oltrebaseMessage') }}></div>
              <div>
                {' '}
                <h5 className="text-secondary subtitle">
                  {' '}
                  {t('focusProject')} : {t('oltrebaseFocusProjects')}{' '}
                </h5>
              </div>
              <div>
                {' '}
                <p dangerouslySetInnerHTML={{ __html: t('oltrebaseFocusProjectsMessage') }}></p>
              </div>
            </div>
          </Section>
          <Section>
            <div className="d-flex flex-column">
              <div className="row">
                <div className="col-auto me-auto">
                  <h4 className="text-primary">{t('juniorSysadmin')}</h4>
                </div>
                <div className="col-auto">
                  <div className="row">
                    {' '}
                    <div className="col-auto col-xs-12 text-end">
                      <small>{t('otherworkDuration')}</small>{' '}
                    </div>
                  </div>
                </div>
              </div>

              <p> {t('otherworkmessage')}</p>
            </div>
          </Section>
          <Section>
            <div className="d-flex flex-column">
              <div className="position-relative">
                <h4 className="text-primary">{t('fullTechnicalKnowledge')}</h4>
                <div className="position-absolute top-50 end-0 translate-middle-y"></div>
              </div>
              <div>
                <KnowledgeViewer />
              </div>
            </div>
          </Section>
        </div>
      </div>
    </div>
  
  );
};

export default Body;
